/*------------------------------------*\
    CENTRAL APP — MODULE DISPATCHER

    Bind jQuery plugins to elements via data-module attribute.

    USAGE

    <div data-module="modal"></div>
    <div data-module="toggle,camcom-woocommerce"></div>

    The value must match a key in moduleAliases or a $.fn method name directly.

    SCRIPTS ONLY WHERE USED (2026-10-13). Only the core modules are in this
    file (global/scripts/modules.json). Any other module is its own file: when
    a page has a module's markup and the module is not loaded yet, it is fetched
    — with whatever it needs first, the slider library for a carousel — and
    bound when it arrives. The record is written into this file by the build
    (gulpfile.js, from modules.json), not handed over by the page, so a page
    served from a cache built before a module moved still finds it. The theme
    may already have enqueued a module up front
    (camcom-v2/includes/script-modules.php); it then marks itself loaded and is
    simply bound.

    camcom.need( [ 'slick' ], callback ) is the same loader for code that wants
    a unit without having its markup — a slider that only appears in some states.

\*------------------------------------*/
var app = (function ($) {

    // Maps data-module keys to $.fn method names where they differ.
    // Add entries here when a plugin name can't match its data-module key directly.
    var moduleAliases = {
        'toggle':              'camcomToggle',
        'camcom-woocommerce':  'camcomWooCommerce',
        'camcom-cart-drawer':  'camcomCartDrawer',
        'camcom-review-form':  'camcomReviewForm',
        'camcom-user-access':  'camcomAccess',
        'camcom-sidebar':      'camcomSidebar',
        'camcom-product-gallery': 'camcomProductGallery',
        'camcom-sticky-atc':   'camcomStickyAtc',
        'camcom-copy-link':    'camcomCopyLink',
        'camcom-set-password': 'camcomSetPassword',
        'camcom-chip-filter':  'camcomChipFilter',
        'camcom-loyalty-sync': 'camcomLoyaltySync',
        'camcom-marketing-popup': 'camcomMarketingPopup',
        'faq':                 'camcomFaq'
    };

    // Written in by the build: { units: { name: { src, ver, needs } }, keys: { data-module key: unit } }.
    var manifest = {} /* MODULES MANIFEST */,
        registry = window.camcomScripts = window.camcomScripts || { loaded: [] },
        base     = ((window.ajax_variables || {}).template_directory_uri || '') + '/scripts/',
        pending  = {};

    // Each unit is fetched once; every caller waiting on it shares one promise.
    // A unit the theme enqueued up front adds itself to `loaded` as it runs
    // (after this file), so the list is read at call time, not here.
    var load = function (name) {

        if (pending[name]) { return pending[name]; }

        if ($.inArray(name, registry.loaded) > -1) {
            pending[name] = $.Deferred().resolve().promise();
            return pending[name];
        }

        var unit = (manifest.units || {})[name];

        if (!unit) {
            pending[name] = $.Deferred().reject().promise();
            return pending[name];
        }

        pending[name] = need(unit.needs || []).then(function () {
            return $.ajax({
                url:      base + unit.src + '?ver=' + unit.ver,
                dataType: 'script',
                cache:    true
            });
        });

        return pending[name];

    };

    // Load units in parallel; each unit's own needs still load before it
    // (load() recurses into need() for unit.needs before fetching it).
    var need = function (names, callback) {

        var chain = $.when.apply($, $.map(names, load));

        if (callback) { chain.done(callback); }

        return chain;

    };

    var bind = function (elem, module) {

        var fn = moduleAliases[module] || module;

        if ($.fn[fn]) {
            elem[fn]();
            return;
        }

        if ((manifest.keys || {})[module]) {
            load(manifest.keys[module]).done(function () {
                if ($.fn[fn]) { elem[fn](); }
            });
        }

    };

    var init = function () {

        $('[data-module]').each(function () {

            var elem    = $(this),
                modules = elem.attr('data-module');

            if (!modules) { return; }

            $.each(modules.split(','), function (i, module) {

                bind(elem, $.trim(module));

            });

        });

    };

    return { init: init, need: need };

}(jQuery));

var camcom = { need: app.need };

jQuery(function () {
    app.init();
});
